import React from 'react'
import styled, { css } from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { PairLink } from '@root/entities/pair/ui/common'
import { CandleChartIcon } from '@root/shared/ui-kit'

import { PairExploreItemChart } from './pair-explore-item-chart'

import type { PairModel, PriceChartInterval } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  interval: PriceChartInterval
} & ClassNameProps

export const PairExploreItemChartTooltip: React.FC<Props> = ({
  pair,
  interval,
  className,
}) => (
  <Root pair={pair} className={className}>
    <Tooltip
      content={
        <ChartHolder>
          <PairExploreItemChart
            pair={pair}
            interval={interval}
            css={css`
              width: 100%;
              height: 100%;
            `}
          />
        </ChartHolder>
      }
      side="top"
      sideOffset={3}
      align="end"
      alignOffset={0}
      css={css`
        border-radius: 6px;
        border: 0.6px solid var(--backgroundA-3);
        background: var(--backgroundA-1);
        backdrop-filter: blur(13px);
        padding: 0;
      `}
    >
      <ChartButton>
        <CandleChartIcon height={18} />
      </ChartButton>
    </Tooltip>
  </Root>
)

const Root = styled(PairLink<PairModel>)`
  display: grid;
  margin-top: 2px;
`

const ChartButton = styled.div`
  pointer-events: auto;
  background: rgba(var(--background-12-rgb), 0.04);
  color: var(--text-11);

  display: grid;
  place-content: center;
  width: 26px;
  height: 24px;
  border-radius: 6px;

  transition: all 0.1s linear;

  svg {
    color: var(--text-11);
  }

  &:hover {
    background: rgba(var(--background-12-rgb), 0.16);

    svg {
      color: var(--text-12);
    }
  }
`

const ChartHolder = styled.div`
  width: 194px;
  height: 61px;
  padding: 7px;
  box-sizing: border-box;
`
